import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Radio, RadioGroup } from 'react-icheck';
import 'icheck/skins/all.css';
import { Col, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap';

const RadioComponent = ({ name, label, required, entries, horizontal, inline, labelCol = 3, valueCol = 9, help, input: { onChange, value = '' }, meta: { touched, error, warning }, ...props }) => {
	const validationState = touched && (error && "error") || (warning && "warning") || null;

	const formControl = <RadioGroup name={name} value={value.toString()} onChange={onChange}>
		{entries && entries.map(entry => {
			const radio = <Radio
				value={entry.value}
				radioClass='iradio_minimal-grey bg'
				increaseArea='20%'
				labelClassName={value === entry.value ? 'checked' : ''}
				label={<span style={inline && { marginRight: '20px' }}>{entry.label}</span>}
				{...props}
			/>;
			return inline ? [radio] : [radio, <br />];
		})}
	</RadioGroup>;
	const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
	const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
	const labelHint = required && <em style={{ color: '#D62229' }}>*</em>;

	if (horizontal) {
		return (
			<FormGroup validationState={validationState} className='row'>
				<Col componentClass={ControlLabel} sm={labelCol}>
					{label}{labelHint}
				</Col>
				<Col componentClass={ControlLabel} style={{ textAlign: 'left' }} sm={valueCol}>
					{formControl}
					{errorBlock}
					{helpBlock}
				</Col>
			</FormGroup>
		);
	}

	return (
		<FormGroup validationState={validationState}>
			<ControlLabel>{label}{labelHint}</ControlLabel>
			{formControl}
			{errorBlock}
			{helpBlock}
		</FormGroup>
	);
};

RadioComponent.propTypes = {
	horizontal: PropTypes.bool,
	input: PropTypes.object,
	label: PropTypes.string,
	help: PropTypes.string,
	meta: PropTypes.object,
	entries: PropTypes.array,
	inline: PropTypes.bool,
	required: PropTypes.bool
};

export default RadioComponent;